export default __webpack_public_path__ + "static/media/ShipIsometric@3x.8b53246c.png";